import { createSlice } from "@reduxjs/toolkit";

export interface CustomerChatState {
  showChat: boolean;
}

const initialState: CustomerChatState = {
  showChat: false,
};

const customerChatSlice = createSlice({
  name: "customerChat",
  initialState,
  reducers: {
    openCustomerChat: (state) => {
      state.showChat = true;
    },
    closeCustomerChat: (state) => {
      state.showChat = false;
    },
    toggleCustomerChat: (state) => {
      state.showChat = !state.showChat;
    },
  },
});

export const { openCustomerChat, closeCustomerChat, toggleCustomerChat } = customerChatSlice.actions;

export const customerChatSelector = (state: any) => state.customerChat;

export default customerChatSlice.reducer; 